module.exports = __webpack_public_path__ + "static/img/payletter.d4afbbd2.png";